// ** Icons Import
import { Circle, Percent } from "react-feather";
export default [
  {
    id: "region",
    title: "Region Config",
    icon: <Percent size={20} />,
    badge: "light-warning",
    // badgeText: "2",
    children: [
      {
        id: "regionConfig",
        title: "Defaults",
        icon: <Circle size={12} />,
        navLink: '/region/defaults'
      },
      {
        id: "rbcr",
        title: "Commission Ranges",
        icon: <Circle size={20} />,
        badge: "light-warning",
        navLink: "/rbcr",
      },
    ],
  },
];
